const updates = [
  { tag: '重磅', title: '某顶流男星深夜密会神秘女子，疑似恋情曝光引热议', time: '2小时前', hot: true },
  { tag: '独家', title: '知名导演新片拍摄现场黑料流出，剧组内部矛盾升级', time: '5小时前', hot: true },
  { tag: '热议', title: '综艺节目录制突发意外，嘉宾现场翻车视频全网疯传', time: '8小时前', hot: true },
  { tag: '追踪', title: '网红带货翻车后续：品牌方发声明要求赔偿巨额损失', time: '12小时前', hot: false },
  { tag: '爆料', title: '某女星社交媒体小号被扒，内容惊人引发粉丝脱粉潮', time: '1天前', hot: false },
  { tag: '深挖', title: '娱乐圈资本局曝光：多位明星卷入投资陷阱损失惨重', time: '1天前', hot: false },
  { tag: '快讯', title: '热门影视剧原作者发声质疑改编，编剧团队回应引争议', time: '2天前', hot: false },
  { tag: '回顾', title: '年度十大黑料事件盘点：哪些瓜让你至今记忆犹新', time: '2天前', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新爆料
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            实时追踪娱乐圈最新黑料事件，每日不间断更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="relative pl-8 pb-8 last:pb-0 group"
            >
              <div className="absolute left-0 top-0 bottom-0 flex flex-col items-center">
                <div className={`w-3 h-3 rounded-full border-2 flex-shrink-0 ${
                  item.hot
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-background-100 border-secondary-300'
                }`}></div>
                {idx < updates.length - 1 && (
                  <div className="w-0.5 flex-1 bg-background-300 mt-1"></div>
                )}
              </div>

              <div className="pb-2">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className={`inline-block px-2 py-0.5 rounded text-xs font-label font-semibold whitespace-nowrap ${
                    item.hot
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  {item.hot && (
                    <span className="text-xs text-accent-600 font-label font-semibold whitespace-nowrap">
                      🔥 热门
                    </span>
                  )}
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors cursor-pointer">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}